import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "sign-text" }
const _hoisted_3 = { class: "sign-count" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyBlock = _resolveComponent("CompanyBlock")!
  const _component_PInput = _resolveComponent("PInput")!
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Настройки", -1)),
    (_ctx.company?.name)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_CompanyBlock, { company: _ctx.company }, null, 8, ["company"]),
          _createElementVNode("p", _hoisted_2, [
            _cache[2] || (_cache[2] = _createTextVNode(" Остаток подписей: ")),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.signings), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isKeyAdded)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "success-block" }, " API-ключ добавлен ", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PInput, {
          placeholder: "API-ключ",
          modelValue: _ctx.apiKey,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiKey) = $event)),
          status: true
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_PButton, {
        title: "Сохранить",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
      })
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("section", { class: "no_profile" }, [
      _createTextVNode(" Если у вас нет аккаунта, "),
      _createElementVNode("a", {
        href: "https://podpislon.ru/signup?utm_source=yclients&utm_medium=market",
        target: "_blank"
      }, "зарегистрируйтесь")
    ], -1))
  ], 64))
}